
export enum NoteType {
    Automatic,
    Manual,
}
